import client from '../api/client';
import { APP_VERSION } from '../pages/AppInfoPage';

// In-memory dedupe: same error key reported at most once per window.
const WINDOW_MS = 60000;
const recent = new Map(); // key -> last-sent timestamp

function shouldSend(key) {
  const now = Date.now();
  for (const [k, t] of recent) {
    if (now - t > WINDOW_MS) recent.delete(k);
  }
  const last = recent.get(key);
  if (last && now - last < WINDOW_MS) return false;
  recent.set(key, now);
  return true;
}

export function reportError(info) {
  try {
    if (!info) return;
    const message = String(info.message || 'Unknown error');
    const errorType = info.error_type || 'ClientError';
    const key = `${errorType}:${message}`.slice(0, 200);
    if (!shouldSend(key)) return;
    client.post('/client-errors', {
      message,
      error_type: errorType,
      stack: info.stack ? String(info.stack).slice(0, 8000) : undefined,
      url: info.url || (typeof window !== 'undefined' ? window.location.href : ''),
      status_code: info.status_code,
      app_version: APP_VERSION,
      context: info.context || {},
    }).catch(() => {});
  } catch {
    /* the reporter must never throw */
  }
}

export function installGlobalErrorReporting() {
  if (typeof window === 'undefined' || window.__errorReportingInstalled) return;
  window.__errorReportingInstalled = true;
  window.addEventListener('error', (e) => {
    reportError({
      message: e.message,
      stack: e.error && e.error.stack,
      error_type: (e.error && e.error.name) || 'Error',
      url: window.location.href,
    });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason || {};
    reportError({
      message: r.message || String(r),
      stack: r.stack,
      error_type: 'UnhandledRejection',
      url: window.location.href,
    });
  });
}
